<template>
  <div>
    <v-card class="pb-3 mx-auto addLocationBg" rounded="xxl" style="text-align-last: center;" >
      <v-img
          class="white--text align-end"
          height="100px"
          src="~@/assets/beach-1110498_640.jpg"
          position="top center"
      >
        <v-card-title class="pb-0">Add a Place You Like</v-card-title>
        <v-card-subtitle class="mt-0 pb-1">Share Recommendation with the Community</v-card-subtitle>
      </v-img>


      <v-card-text class="my-3 date-picker-container">
      <gmap-autocomplete class="hotspotAutoComplete" :key="autocompleteKey" @place_changed="initMarker" placeholder="Choose Recommended Place" :types="['establishment']"></gmap-autocomplete>

      </v-card-text>
      <v-card-actions>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="ml-3" small @click="closeAddHotspotDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn style="text-transform: capitalize" rounded color="primary" class="mr-3" small @click="like_hotspot">Done</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="hotspotAddedDialogVisible">
      <v-card color="primary lighten-1" dark>
        <v-card-title v-if="num_of_likes" style="word-break: normal">Thanks for Sharing! <br> {{num_of_likes}} Members already liked {{addedHotspotName}}</v-card-title>
        <v-card-title v-else style="word-break: normal">Thanks for Sharing! <br> You are the First to Like {{addedHotspotName}}!</v-card-title>
        <v-card-actions>
          <v-btn style="text-transform: capitalize" rounded color="primary" class="ml-3" small @click="addedHotspotDialogCancel">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn style="text-transform: capitalize" rounded color="primary" class="mr-3" small @click="addedHotspotDialogMore">Add Another</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right" class="missingLocationAlert">
      Location is Missing
    </v-alert>
  </div>
</template>

<script>
import {allMixins} from "@/mixins/allMixins";
import {store} from "@/store";
import supabase from "@/lib/supabaseClient";

export default {
  name: "AddHotspot",
  mixins: [allMixins],
  data() {
    return {
      autocompleteKey: 0,
      isPublicStay: store.state.userData.privacyDefault,
      existingPlace: null,
      locationAddedDialogVisible: false,
      addedLocationName: null,
      missingDataAlert: false,
      hotspotAddedDialogVisible: false,
      num_of_likes: null,
      addedHotspotName: null,
    }
  },


  methods: {
    closeAddHotspotDialog() {
      this.$emit('closeAddHotspotDialog');
    },
    addedHotspotDialogCancel() {
      this.hotspotAddedDialogVisible = false
      this.$emit('closeAddHotspotDialog');
    },
    addedHotspotDialogMore() {
      this.hotspotAddedDialogVisible = false
      this.autocompleteKey += 1
    },
    initMarker(loc) {
      this.existingPlace = loc;
    },
    async checkRowExistence(idToCheck) {
      const { data, error } = await supabase
          .from('hotspots')
          // .select('*', { count: 'exact', head: true })
          .select('likes, name')
          .eq('id', idToCheck);
      if (error) {
        console.error('Error checking row existence:', error);
        return false; // Handle the error as needed
      }
      if (data.length === 0) {
        console.log('location does not exist')
        return false
      } else {
        if (data[0]['likes'] >= 1) {
          this.num_of_likes = data[0]['likes']
          this.addedHotspotName = data[0]['name']
        } else {
          this.num_of_likes = 0
          this.addedHotspotName = data[0]['name']
        }
        console.log(data)
        return data.length > 0;
      }
    },

    async create_hotspot_in_db(place) {
      const alreadyExists = await this.checkRowExistence(place.place_id)
      if (alreadyExists) {
        console.log('location exists')
        return true
      }
      this.addedHotspotName = place.name
      const { data, error } = await supabase
          .from('hotspots')
          .insert([
            { id: place.place_id, name: place.name, rating: place.rating, user_ratings_total: place.user_ratings_total, position: place.geometry.location, types: place.types},
          ])
          .select()
      if (error) {
        console.log(error)
      } else {
        console.log(data)
        return true
      }
    },

    async like_hotspot() {
      if (!this.existingPlace) {
        this.missingDataAlert = true
        return
      }
      store.commit('loadingOn')
      await this.create_hotspot_in_db(this.existingPlace)
      const { data, error } = await supabase
          .from('hotspot_likes')
          .insert([
            { id: store.state.userData.userId + '_' + this.existingPlace.place_id, user_id: store.state.userData.userId, google_place_id: this.existingPlace.place_id },
          ])
          .select()
      if (error) {
        console.log(error)
      } else {
        console.log(data)
        await store.dispatch('getUserLikes')
        await store.dispatch('getLikedHotspots')
        this.$emit('update_likes_dict');
        this.$emit('getNomadsHotSpots');
        this.hotspotAddedDialogVisible = true
        // this.$emit('closeAddHotspotDialog');
      }
      store.commit('loadingOff')
    },
  }
}
</script>

<style>
.addLocationBg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}
.hotspotAutoComplete{
  background-color: #d9e4f6;
  border-radius: 15px;
  width: 80vw;
  font-size: larger;
}
.date-picker-container {
  display: flex;
  justify-content: center; /* Aligns vertically center */
  align-items: center; /* Aligns horizontally center */
  flex-direction: column; /* Stack children vertically */
}
.missingLocationAlert {
  position: fixed;
  top: 5vh;
  width: 70vw;
  left: 15vw;
}
</style>
